/**
 * number
 */

import { Row, Col } from 'antd';

const Number = () => {
    return <>
        <div style={{ padding: '40px 0', color: '#fff', fontSize: '18px', textAlign: 'center' }}>
            <Row>
                <Col offset={4} span={4}>
                    <p><span style={{ fontSize: '50px' }}>10</span>年</p>
                    <p>信息化系统运维、建设、集成经验</p>
                </Col>
                <Col span={4}>
                    <p><span style={{ fontSize: '50px' }}>20</span>+</p>
                    <p>商标、专利、著作权</p>
                </Col>
                <Col span={4}>
                    <p><span style={{ fontSize: '50px' }}>100</span>家</p>
                    <p>服务的客户</p>
                </Col>
                <Col span={4}>
                    <p><span style={{ fontSize: '50px' }}>360</span>行</p>
                    <p>全行业覆盖</p>
                </Col>
            </Row>
        </div>
    </>
}

export default Number;